export default __webpack_public_path__ + "static/media/people-fill-gray5-18.c386104e.svg";